var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tools"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2917 5.04167L16.9583 8.70833M11 7.33333L6.41667 2.75L2.75 6.41667L7.33333 11M6.41667 7.33333L5.04167 8.70833M14.6667 11L19.25 15.5833L15.5833 19.25L11 14.6667M14.6667 15.5833L13.2917 16.9583M2.75 19.25H6.41667L18.3333 7.33333C18.8196 6.8471 19.0927 6.18763 19.0927 5.5C19.0927 4.81237 18.8196 4.1529 18.3333 3.66667C17.8471 3.18044 17.1876 2.90728 16.5 2.90728C15.8124 2.90728 15.1529 3.18044 14.6667 3.66667L2.75 15.5833V19.25Z",
    stroke: "#182553",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.837804c34f5a0cadc90f5b60c3258724.svg";
export { ForwardRef as ReactComponent };